import { roles } from 'features/hoc';

export const supportQriosRoleRules = {
  menu: { min: roles.admin.value },
  letsTalk: { min: roles.admin.value },
};
